function handleScrollAttempt(event) {
  const isScrollDown = detectScrollDirection(event) === 'down';

  // Only trigger at the top AND on downward scroll attempt
  if (!isScrollDown) return;

  if (!document.body.classList.contains('scrolled')) {
    document.body.classList.add('scrolled');
    document.body.classList.add('pointer-none');

    setTimeout(() => {
      document.body.classList.remove('pointer-none');
    }, 1000);
  }
}

// 🔍 Determine if the scroll attempt is downward
function detectScrollDirection(event) {
  if (event.type === 'wheel') {
    return event.deltaY > 0 ? 'down' : 'up';
  }

  if (event.type === 'touchmove') {
    const currentY = event.touches[0].clientY;
    if (typeof detectScrollDirection.lastY !== 'undefined') {
      const direction = currentY < detectScrollDirection.lastY ? 'down' : 'up';
      detectScrollDirection.lastY = currentY;
      return direction;
    }
    detectScrollDirection.lastY = currentY;
    return null;
  }

  if (event.type === 'keydown') {
    return ['ArrowDown', 'PageDown', ' '].includes(event.key) ? 'down' : 'up';
  }

  return null;
}

// Reset touch Y position when touch ends
window.addEventListener('touchend', () => {
  delete detectScrollDirection.lastY;
});

// Reset when user scrolls back to top
function monitorScrollTop() {
  console.log(window.scrollY)
  if (window.scrollY === 0) {
    document.body.classList.remove('pointer-none');
    document.body.classList.remove('scrolled');
      setTimeout(function(){ 
         if (window.scrollY === 0) {
// document.body.classList.remove('pointer-none');
   // document.body.classList.remove('scrolled');
         }
}, 2750);
  }
 
}



// 📌 Listeners
window.addEventListener('scroll', monitorScrollTop, { passive: true });
window.addEventListener('wheel', handleScrollAttempt, { passive: false });
window.addEventListener('touchmove', handleScrollAttempt, { passive: false });
window.addEventListener('keydown', handleScrollAttempt, { passive: false });




 setTimeout(function(){ 
  if (window.scrollY > 200) {
    
    document.body.classList.add('scrolled');
    
  }
}, 1000);

